import React from "react";
import "./swap-button.css";
import { BaseUrl } from "../../../../../config.js";
import { toast } from "react-toastify";

const SwapButton = ({ data, onClick, alloyWheel, ToastMessage }) => {
  return (
    <>
      {data.map((item) => (
        <div
          className="footer-items"
          style={{
            opacity: item?.visibility === false && 0.5,
          }}
        >
          {item.colorCode && !alloyWheel ? (
            <div
              className="parallelogram-u400-color"
              onClick={() =>
                item?.visibility === false
                  ? ToastMessage("Please Choose a kit to proceed.")
                  : onClick(item.id, item.name, item.price)
              }
            >
              <div style={{ backgroundColor: "#" + item.colorCode }}></div>
            </div>
          ) : (
            <div
              className="swap-button"
              style={{
                // background: item.status && "#FFE100",
                // border: item.status && "1.5px solid #555555",
                //boxShadow: item.status && "0px 0.5rem 6px rgba(0, 0, 0, 0.3)",
                // borderRadius: item.status && "1.25rem",
                // margin: "0 2rem 0 2rem",

                border: item.status && "0.19rem solid #FFE100",
              }}
              onClick={() =>
                item?.visibility === false
                  ? ToastMessage("Please Choose a kit to proceed.")
                  : onClick(item.id, item.name, item.price)
              }
            >
              <img
                className="swap-icon"
                src={BaseUrl() + item.path}
                alt="swap"
              />
            </div>
          )}

          <p
            className="footer-label mediumFont"
            style={{
              color: item.status && "#FFE100",
            }}
          >
            {item.name}
          </p>
        </div>
      ))}
    </>
  );
};

export default SwapButton;
